import React from 'react';
import './lead info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message, TreeSelect } from "antd";
import moment from 'moment';
const { TreeNode } = TreeSelect;
class leadInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    page: 1,
    pages: 1,
    id: this.props.location.state.data.id,
    fullname: this.props.location.state.data.fullname ? this.props.location.state.data.fullname : '',
    phone: this.props.location.state.data.phone ? this.props.location.state.data.phone : '',
    country: this.props.location.state.data.country ? this.props.location.state.data.country.id : null,
    broker: this.props.location.state.data.broker ? this.props.location.state.data.broker : null,
    brokerId: this.props.location.state.data.broker ? this.props.location.state.data.broker.id : null,
    campaign: this.props.location.state.data.campaign ? this.props.location.state.data.campaign.id : null,
    createdAt: this.props.location.state.data.createdAt,
    status: this.props.location.state.data.status,
    caountry: [],
    countries: [],
    campaigns: [],
    brokers:[]
  };

  constructor(props) {
    super(props)
    if(this.props.location.state.actionType === "EDIT"){
      this.getCampaignBrokers(this.props.location.state.data.campaign.id)
    }
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    this.getCampaigns()
    
    this.getCountries()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getCountries = () => {
    axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
    }).then(response => {
      console.log("countries", response.data)
      this.setState({ countries: response.data.data })
    })
      .catch(error => {
        console.log("ALL countries ERROR")
        console.log(error.response)
      })
  }
  getCampaigns = () => {
    axios.get(`${BASE_END_POINT}campaigns/shortList/get`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    }).then(response => {
      console.log(response.data)
      this.setState({ campaigns: response.data.data })
    })
    .catch(error => {
      console.log("ALL campaigns ERROR")
      console.log(error.response)
    })
  }
  getCampaignBrokers = (campaign) => {
    axios.get(`${BASE_END_POINT}campaigns/${campaign}/members/get?limit=1000&justBrokers=true`, {
        headers: {
            'Authorization': `Bearer ${this.props.currentUser.token}`,
            'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        }
    }).then(response => {
        console.log("brokers   ", response.data)
        let broker = this.state.broker
        if(response.data.data.length == 0) broker = null
        this.setState({ brokers: response.data.data,broker:broker })
    })
    .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
    })
  }
  update = () => {
    const { fullname, phone, brokerId, campaign, country } = this.state
    if (hasValue(fullname) && hasValue(phone) && campaign != null &&brokerId != null) {
      let l = message.loading('Wait..', 2.5)
      const data = {
        'fullname': fullname,
        'phone': phone,
        'broker': brokerId,
        'campaign': campaign,
        'country': country
      }
      axios.put(`${BASE_END_POINT}leads/${this.props.location.state.data.id}`, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en',
        },
      })
        .then(response => {
          console.log("lead UPDATED  ", response.data)
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
        })
        .catch(error => {
          console.log(error.response)
          if (error.response.data.errors.msg[0].msg) {
            l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))

          } else {
            l.then(() => message.error(allStrings.error, 2.5))

          }
        })
    }
  }

  delete = () => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}leads/${this.props.location.state.data.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    })
      .then(response => {
        console.log("lead DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  submitHandler = event => {
    event.preventDefault();
    console.log(event.target.className)
    event.target.className += " was-validated";
    this.update()
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('LEADS')) return <Redirect to='/Home' />
    return (
      <div className="App">
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <div className="infoCard">
                <Card className="editCard">
                  <CardMedia
                    style={{ height: "0px" }}
                  />
                  <CardHeader></CardHeader>
                  <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                    <div className="topIcon">
                      <span className="material-icons" style={{ color: 'white', fontSize: 23 }}>contact_phone</span>
                    </div>
                    <div className="tableTitle" style={{
                      display: this.props.isRTL ? 'inline-block' : 'inline-block', marginTop: this.props.isRTL ? '-60px' : '-60px',
                      marginLeft: this.props.isRTL ? '0' : '7.5rem', marginRight: this.props.isRTL ? '8.5rem' : '0'
                    }}>
                      <p>{this.state.actionType === "VIEW" ? allStrings.info : allStrings.edit}</p>
                    </div>
                  </div>
                  <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                    <MDBContainer>

                      <MDBRow>
                        <MDBCol md="12">
                          <form
                            className="needs-validation"
                            onSubmit={this.submitHandler}
                            noValidate
                          >
                            <div className="grey-text">
                              {this.state.actionType === "VIEW" &&
                                <MDBRow style={{flexDirection: this.props.isRTL?'row-reverse':'row'}}>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form6015" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.id} type="text" id="form6015" className="form-control" />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form6005" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.status === "PENDING" ? allStrings.pending : this.state.status === "FOLLOWING" ? allStrings.following :this.state.status === "SALE-DONE" ?allStrings.saleDone: this.state.status === "NOT-QUALIFIED" ?allStrings.notQualified  :allStrings.noAnswer} type="text" id="form6005" className="form-control" />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                              }

                              <MDBRow>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.name}</label>
                                    <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.fullname} type="text" id="form645" name="fullname" className="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.phone}</label>
                                    <input onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.phone} type="text" id="form56" name="phone" className="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>

                              <MDBRow>
                                <MDBCol md="6" sm="6">
                                  <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.country}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={true}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    value={this.state.country}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.country}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ country: value });
                                    }}

                                  >
                                    {this.state.countries.map(val => (
                                      <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                                    ))}
                                  </TreeSelect>
                                </MDBCol>
                                <MDBCol md="6" sm="6">
                                  <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.campaign}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={false}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem' }}
                                    value={this.state.campaign}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.campaign}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ campaign: value });
                                      this.getCampaignBrokers(value)
                                    }}

                                  >
                                    {this.state.campaigns.map(val => (
                                      <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                                    ))}
                                  </TreeSelect>
                                </MDBCol>
                              </MDBRow>
                              {this.state.actionType === "EDIT" && 
                              <MDBRow style={{flexDirection: this.props.isRTL?'row-reverse':'row'}}>
                                <MDBCol md="6" sm="6">
                                    <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.broker}</label>
                                    <TreeSelect
                                        virtual={false}
                                        showSearch={true}
                                        disabled={this.state.actionType ==="EDIT"?false:true}
                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem', }}
                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                        placeholder={allStrings.broker}
                                        value={this.state.broker?this.state.broker.id:null}
                                        onChange={(value) => {
                                            console.log(value);
                                            this.setState({ brokerId: value });
                                        }}
                                    >
                                        {this.state.brokers.map((val) => (
                                            <TreeNode value={val.id} title={val.fullname} key={val.id} />))}
                                    </TreeSelect>
                                </MDBCol>
                                <MDBCol md="6" sm="6"></MDBCol>
                              </MDBRow>
                              }
                              {this.state.actionType === "VIEW" && this.state.createdAt &&
                                <MDBRow>
                                  <MDBCol md="12">
                                    <div className="md-form">
                                      <label htmlFor="form062" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.date}</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={moment(this.state.createdAt).format('lll')} type="text" id="form062" className="form-control" validate />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>

                                </MDBRow>
                              }
                              {this.state.actionType === "VIEW" &&
                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                  <MDBCol md="10" xs="10">
                                    <div class="md-form">
                                      <label for="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.broker}</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.broker ? this.state.broker.fullname : ''} type="text" id="form80" class="form-control" />
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="2" xs="2">

                                    <p style={{ textAlign: 'center', marginTop: '2rem', color: '#2BBBAD' }}>
                                      <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                        onClick={() => { this.props.history.push('userInfo', { data: this.state.broker, actionType: 'VIEW' }) }}>
                                        remove_red_eye
                                      </span>
                                      <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                        onClick={() => { this.props.history.push('userInfo', { data: this.state.broker }) }}>
                                        {allStrings.show}
                                      </span>
                                    </p>
                                  </MDBCol>
                                </MDBRow>
                              }
                            </div>
                            <br></br>
                            <br></br>
                            <div className="text-center">
                              {this.state.actionType==="EDIT"&&
                                <MDBBtn type="submit" style={{ background: '#233b5b' }} rounded className="btn-block z-depth-1a" >
                                  <MDBIcon icon="edit" className="mr-2" />
                                  {allStrings.update}
                                </MDBBtn>
                              }{this.state.actionType === "VIEW" && this.state.actionType === "VIEW" &&
                                <MDBBtn onClick={() => { this.delete() }} rounded color="danger" className="btn-block z-depth-1a">
                                  <MDBIcon icon="trash-alt" className="mr-2" />
                                  {allStrings.remove}
                                </MDBBtn>
                              }

                            </div>
                          </form>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </CardContent>
                </Card>
              </div>
            </MDBCol>
          </MDBRow>

        </MDBContainer>

      </div>
    )
  }
}


const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(leadInfo)
);